import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "report-list" }

import { reactive, getCurrentInstance } from 'vue'
import Keys from '@/constant/key'
import { joinParams } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExportByNumOrMoney',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const filterData = reactive({
    from: '',
    to: ''
})

const exportReport = (type) => {
    if(!filterData.from || !filterData.to){
        return proxy.$message({ type: 'error', message: '请选择时间范围' })
    }
    
    const params = {
        ...filterData,
    }
    window.open(`${Keys.baseUrl}${type}?${joinParams(params)}&is_export=1`)
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, {
    class: "mb15",
    shadow: "hover"
  }, {
    header: _withCtx(() => _cache[7] || (_cache[7] = [
      _createElementVNode("div", {
        class: "card-header",
        style: {"font-size":"14px","font-weight":"bold"}
      }, [
        _createElementVNode("span", null, "报表导出")
      ], -1)
    ])),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: true,
        class: "filter-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "时间：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: filterData.from,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterData.from) = $event)),
                type: "date",
                placeholder: "选择开始日期",
                class: "filter-item date-input",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"]),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "filter-divider" }, " -- ", -1)),
              _createVNode(_component_el_date_picker, {
                modelValue: filterData.to,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterData.to) = $event)),
                type: "date",
                placeholder: "选择结束日期",
                class: "filter-item date-input",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (exportReport('/sys/admin/yuantong')))
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("圆通明细报表")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (exportReport('/sys/admin/yuantong_count')))
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("圆通汇总报表")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (exportReport('/sys/admin/productc_count')))
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode("畅销商品汇总")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (exportReport('/sys/admin/productz_count')))
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode("滞销商品汇总")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (exportReport('/sys/admin/sale_coupon_consumption')))
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [
            _createTextVNode("企业销售券-消费")
          ])),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})